module.exports = __webpack_public_path__ + "img/sports.897fe7fb.png";